/****************************************************************************
* Header primary
****************************************************************************/

function fnHeaderPrimary( i, oHeader ) {

	/**
	* Element
	*/
	var oHeader 					= $( oHeader ),
		oMenuButton					= $( 'aside.menu-button .button', oHeader ),
		oMenuItem 					= $( 'ul.main-menu li', oHeader ),
		oBackgroundImages 			= $( 'ul.background-images', oHeader );

	/***************
	* Menu open/close
	***************/
	oMenuButton.on( 'click', function() {

		// Open menu
		oHeader.toggleClass( 'menu-is-open' );
		$( this ).toggleClass( 'is-open' );

	} );

	// Activate menu background images (only after 1st menu button click)
	oMenuButton.one( 'click', function() {
	
		// Pre-load background images
		fnBuildBgImages();

		// Bind menu hover to display images
		fnBindMenuHover();

	} );

	/***************
	* Menu item interactions
	***************/

	/**
	* Build background images
	*/
	function fnBuildBgImages() {

		oMenuItem.each( function() {

			var sBgImg 				= $( this ).attr( 'data-background' ),
				sClasses			= '';

			if ( $( this ).hasClass( 'current' ) ) {
				sClasses			= 'class="current"';
			}

			oBackgroundImages.append( '<li ' + sClasses + ' style="background-image:url(' + sBgImg + ');"></li>' );

		} );

	}

	/**
	* Bind background images with menu items
	*/
	function fnBindMenuHover() {

		$( oMenuItem ).not( '.current' ).find( 'a' ).on( {

			mouseenter: function( event ) {

				var iOrder 			= $( this ).parent( 'li' ).index(),
					oBgImage 		= $( 'li', oBackgroundImages ).eq( iOrder );

				oBackgroundImages.addClass( 'is-hovering' );

				oBgImage.addClass( 'hover' );

			},

			mouseleave: function( event ) {

				oBackgroundImages.removeClass( 'is-hovering' );

				$( 'li', oBackgroundImages ).removeClass( 'hover' );

			}

		} );

	}

}



// END OF DOCUMENT
